import React, { useContext, useState } from "react";
import { AuthContext } from "../../../../Context/AuthContextProvider";
import toast from "react-hot-toast";
import { CustomTextField } from "./../../../../Assets/Elements";
import { Rating } from "@smastrom/react-rating"; // Import the Rating component
import "@smastrom/react-rating/style.css"; // Import the styles for the Rating component
import PropTypes from "prop-types";

function getRating(rating) {
  switch (rating) {
    case 1:
      return "Poor 😡";
    case 2:
      return "Average 😕";
    case 3:
      return "Good 😐";
    case 4:
      return "Very good 😊";
    case 5:
      return "Excellent 😍";
    default:
      return "";
  }
}

function ReopenFeedback({ ticket }) {
  ReopenFeedback.propTypes = {
    ticket: PropTypes.any.isRequired,
  };
  const { loginUser, reOpenTicket, feedbackTicket } = useContext(AuthContext);
  const [showReOpenForm, setShowReOpenForm] = useState(true);
  const [showReOpenElements, setShowReOpenElements] = useState(true);
  const [ownerComments, setOwnerComments] = useState("");
  const [isReOpening, setIsReOpening] = useState(false);
  const [rating, setRating] = useState(4); // State for the rating
  const [hoveredRating, setHoveredRating] = useState(0);

  const handleReOpenForm = () => {
    setShowReOpenForm(!showReOpenForm);
    // setShowReOpenElements(!showReOpenElements);
  };

  const handleReOpenElements = () => {
    setShowReOpenElements(true);
  };

  const handleFeedbackElements = () => {
    setShowReOpenElements(false);
  };

  const handleClear = () => {
    setOwnerComments("");
    setShowReOpenForm(true);
    setShowReOpenElements(true);
    setRating(0); // Clear the rating
  };

  const handleReOpen = async () => {
    if (!ownerComments.trim()) {
      toast.error("Please enter comments");
      return;
    }

    if (showReOpenForm && rating === 0) {
      toast.error("Please select a rating");
      return;
    }

    setIsReOpening(true);

    const reOpenData = {
      reOpenedBy: {
        userId: loginUser._id,
        userName: loginUser.username,
      },
      reOpenComments: ownerComments.trim(),
    };

    const feedbackData = {
      feedbackComments: ownerComments.trim(),
      rating,
    };

    try {
      // !showReOpenElements
      //   ? toast.error("Failed to send feedback")
      //   : toast.error("Failed to reopen ticket");
      // setIsReOpening(false);
      // return;
      !showReOpenElements
        ? await feedbackTicket(ticket._id, feedbackData)
        : await reOpenTicket(ticket._id, reOpenData);
      setOwnerComments("");
      setRating(0);
      setIsReOpening(false);
    } catch (error) {
      setShowReOpenElements
        ? toast.error(`Failed to send feedback, error : ${error}`)
        : toast.error(`Failed to reopen ticket, error : ${error}`);
      toast.error("Failed to reply ticket.");
      setIsReOpening(false);
    }
  };

  return (
    <div>
      <div className="mb-[18px]">
        {showReOpenForm ? (
          <div className="flex gap-[16px]">
            <span
              className={`py-[8px] px-[12px] rounded-[8px] bg-[#b99653] hover:bg-[#93693b]  `}
            >
              <button
                className="text-[white]"
                onClick={() => {
                  handleReOpenForm();
                  handleFeedbackElements();
                }}
              >
                Feedback
              </button>
            </span>
            <span
              className={`py-[8px] px-[12px] rounded-[8px] bg-[#b99653] hover:bg-[#93693b]  `}
            >
              <button
                className="text-[white]"
                onClick={() => {
                  handleReOpenForm();
                  handleReOpenElements();
                }}
              >
                ReOpen
              </button>
            </span>
          </div>
        ) : (
          <div>
            {!showReOpenElements && (
              <div className="mb-[16px] flex gap-[16px] items-center">
                <div
                  style={{
                    maxWidth: 180,
                    width: "100%",
                  }}
                >
                  <Rating
                    value={rating}
                    onChange={(selectedValue) => setRating(selectedValue)}
                    onHoverChange={setHoveredRating}
                  />
                </div>
                <div className="flex gap-[12px]">
                  {rating ? (
                    <div className="px-[12px] py-[2px] border rounded-full border-2 shadow-md bg-white">
                      {" "}
                      {`${getRating(rating)}`}
                    </div>
                  ) : null}
                  {hoveredRating ? (
                    <div className="px-[12px] py-[2px] border rounded-full border-2 shadow-md bg-white ">
                      {`${getRating(hoveredRating)}`}
                    </div>
                  ) : null}
                </div>
              </div>
            )}
            <CustomTextField
              label={showReOpenElements ? "ReOpen Comments" : "Feedback"}
              value={ownerComments}
              onChange={(e) => setOwnerComments(e.target.value)}
              width="100%"
              isRequired={false}
              rows={4} // Optional: Adds a textarea-like appearance
              multiline // Enables multiline input
            />
            <div className="flex gap-[12px] mt-[16px]">
              <span
                className={`py-[8px] px-[12px] rounded-[8px] bg-[#b99653] hover:bg-[#93693b]" `}
              >
                <button
                  className="text-[white]"
                  onClick={() => {
                    handleClear(true);
                  }}
                >
                  Cancel
                </button>
              </span>
              <span
                className={` py-[8px] px-[12px] rounded-[8px]  bg-[#93693b] hover:bg-[#b99653]`}
              >
                <button
                  className="text-[white]"
                  onClick={() => {
                    handleReOpen();
                  }}
                >
                  {showReOpenElements
                    ? isReOpening
                      ? "ReOpening..."
                      : "ReOpen"
                    : isReOpening
                    ? "Submitting..."
                    : "Submit"}
                </button>
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ReopenFeedback;
